import { useQuery, useMutation, useQueryClient } from 'react-query';
import { api } from '#/apis';

const buildingOccupancy = async propertyId => {
    const { data } = await api.get(`/entrata/${propertyId}/building-occupancy`);

    return data;
};

const buildingsAndUnits = async propertyId => {
    const { data } = await api.get(`/unit-types/${propertyId}/pricing`);

    return data;
};

const financialReport = async date => {

    const { data } = await api.post('/financial-report', { date });

    return data;
};

const delinquencies = async propertyId => {

    const { data } = await api.get(`/properties/${propertyId}/reports/delinquencies`);

    return data;
};

const matrix = async propertyId => {

    const { data } = await api.get(`/properties/${propertyId}/reports/matrix`);

    return data;
};


const updateDelinquency = async payload => {

    const { data } = api.put(`/report-data/${payload.id}`, payload);

    return data;
};

const getEmployeeDiscounts = async propertyId => {

    const { data } = await api.get(`/entrata/employee-discounts/${propertyId}`);

    return data;
};

const getPropertyNames = async () => {

    const { data } = await api.get('/entrata/property-names');

    return data;
};

export const usePropertyName = (queryOptions = {}) => useQuery('property-names', getPropertyNames, queryOptions);

export const useEmployeeDiscount = (propertyId, queryOptions = {}) => useQuery('employee-discounts', () => getEmployeeDiscounts(propertyId), queryOptions);

export const useBuildingOccupancy = (propertyId, queryOptions = {}) => useQuery(['building-occupancy', propertyId], () => buildingOccupancy(propertyId), queryOptions);

export const useBuildingsAndUnits = (propertyId, queryOptions = {}) => useQuery(['property', propertyId], () => buildingsAndUnits(propertyId), queryOptions);

export const useFinancialReport = (date, queryOptions = {}) => useQuery(['financial-report', date], () => financialReport(date), queryOptions);

export const useDelinquencies = (propertyId, queryOptions = {}) => useQuery(['delinquencies', propertyId], () => delinquencies(propertyId), queryOptions);

export const useMatrix = (propertyId, queryOptions = {}) => useQuery(['matrix', propertyId], () => matrix(propertyId), queryOptions);

export const useUpdateDelinquency = (queryOptions = {}) => {
    const queryClient = useQueryClient();

    return useMutation(payload => updateDelinquency(payload), {
        onSuccess: () => {
            queryClient.invalidateQueries('delinquencies');
        },
        ...queryOptions
    });
};
